
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ComponentInterface } from '@/services/Dev-scrum/interfaces';
import DevScrumRepository from '@/services/Dev-scrum';

@Component({
  inject: [
    'devScrumRepository',
  ],
})
export default class DeleteComponentDialog extends Vue {
  private readonly devScrumRepository!: DevScrumRepository;

  @Prop() private readonly component!: ComponentInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete ${this.component.name}?`;
  }

  private async deleteComponent(): Promise<void> {
    try {
      await this.devScrumRepository.deleteComponent(Number(this.component.id));
      this.$successDialog.show(`Component ${this.component.name} has been deleted.`);
      this.$emit('component-deleted', this.component.id);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
